/**
 * Participant wire events omit the complete public relation and its rank.
 * Keep the canonical snapshot intact until the event-scoped REST reconcile
 * replaces that one relation with the authoritative projection.
 */
export function retainParticipantRelation<T>(prev: T, ..._ignored: readonly unknown[]): T {
  return prev;
}
